import React from 'react';
import { LoadingSpinner } from '@components/LoadingSpinner';
import { NewsListItemHorizontal } from './NewsListItemHorizontal';
import { NewsListItemVertical } from './NewsListItemVertical';
import { NewsList } from '@pages/NewsList/NewsList.types';

interface NewsListContainerProps {
  newsList: NewsList;
  isLoading: boolean;
  notFoundText: string;
}

export const NewsListContainer = ({
  newsList,
  isLoading,
  notFoundText,
}: NewsListContainerProps) => {
  const newsListItems = newsList && newsList.NewsListItems ? newsList.NewsListItems : [];

  return (
    <>
      {newsList && newsList.NewsListItems && newsList.NewsListItems.length == 0 && (
        <div>
          <p>{notFoundText}</p>
        </div>
      )}

      <div className='l-content margin-btm-20'>
        {newsListItems.slice(0, 2).map((newsPage, index) => (
          <div className='l-section l-section-50' key={index}>
            <NewsListItemHorizontal model={newsPage} />
          </div>
        ))}
      </div>

      <div className='l-content margin-btm-20'>
        {newsListItems.slice(2, 5).map((newsPage, index) => (
          <div className='l-section l-section-33 ' key={index}>
            <NewsListItemHorizontal model={newsPage} />
          </div>
        ))}
      </div>

      <div className='l-content'>
        <div className='l-section l-section-block l-section-100'>
          <ul>
            {newsListItems.slice(5).map((newsPage, index) => (
              <li className='c-news-list-block-li' key={index}>
                <NewsListItemVertical model={newsPage} />
              </li>
            ))}
          </ul>

          {isLoading && <LoadingSpinner />}
        </div>
      </div>
    </>
  );
};
